export default __webpack_public_path__ + "static/media/doc.b0813d9d.svg";